import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AssistantsTab = () => {
    const [assistants, setAssistants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [nextPage, setNextPage] = useState(null);
    const [previousPage, setPreviousPage] = useState(null);
    const accessToken = localStorage.getItem("accessToken");

    useEffect(() => {
        fetchData('https://portal.lsb.go.ke/account/assistant_details/');
    }, []);

    const fetchData = async (url) => {
        if (!accessToken) {
            setError("Access token not found. Please log in.");
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            // The API response for assistants might be a direct array
            if (Array.isArray(response.data)) {
                setAssistants(response.data);
                setNextPage(null);
                setPreviousPage(null);
            } else if (response.data.results) { // Or it might be paginated
                setAssistants(response.data.results);
                setNextPage(response.data.links?.next);
                setPreviousPage(response.data.links?.previous);
            }
            
            setError(null);
        } catch (error) {
            setError("Failed to fetch assistants data. Please try again.");
            console.error("Error fetching assistants data:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="text-center p-8">Loading assistants...</div>;
    }

    if (error) {
        return <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4" role="alert"><p>{error}</p></div>;
    }

    return (
        <div>
            <h3 className='text-xl font-bold text-gray-800 mb-4'>Your Assistants</h3>
            <div className="overflow-x-auto bg-white rounded-lg shadow">
                <table className='w-full text-sm text-left text-gray-500'>
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" className="py-3 px-6">Assistant No.</th>
                            <th scope="col" className="py-3 px-6">Name</th>
                            <th scope="col" className="py-3 px-6">ID Number</th>
                            <th scope="col" className="py-3 px-6">Email</th>
                            <th scope="col" className="py-3 px-6">Phone No.</th>
                            <th scope="col" className="py-3 px-6">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {assistants.length > 0 ? assistants.map((assistant, index) => (
                            <tr key={index} className="bg-white border-b hover:bg-gray-50">
                                <td className="py-4 px-6 font-medium text-gray-900">{assistant.assistant_no}</td>
                                <td className="py-4 px-6">{assistant.name}</td>
                                <td className="py-4 px-6">{assistant.id_number}</td>
                                <td className="py-4 px-6">{assistant.email}</td>
                                <td className="py-4 px-6">{assistant.phone_number}</td>
                                <td className="py-4 px-6">
                                    <span className='px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800'>
                                        Active
                                    </span>
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan="6" className="text-center py-8 text-gray-500">No assistants found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {(nextPage || previousPage) &&
                    <div className="flex justify-between items-center p-4">
                        <button
                            onClick={() => fetchData(previousPage)}
                            disabled={!previousPage || loading}
                            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Previous
                        </button>
                        <button
                            onClick={() => fetchData(nextPage)}
                            disabled={!nextPage || loading}
                            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Next
                        </button>
                    </div>
                }
            </div>
        </div>
    );
}

export default AssistantsTab;
